import { render, staticRenderFns } from "./vue-modal.vue?vue&type=template&id=c1053158&"
import script from "./vue-modal.vue?vue&type=script&lang=js&"
export * from "./vue-modal.vue?vue&type=script&lang=js&"
import style0 from "./vue-modal.vue?vue&type=style&index=0&id=c1053158&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports